import { observer } from 'mobx-react-lite';
import { addCalendarButtonText } from './QuickAddCalendarButton.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { SearchScenarioId, exitSearch } from 'owa-search';
import { CalendarIcons } from 'owa-calendar-icons';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { IconButton } from '@fluentui/react/lib/Button';
import { lazyCreateLinkedCalendarAndSelect } from 'owa-create-linked-calendar-and-select';

import { logUsage } from 'owa-analytics';
import { getUserMailboxInfo } from 'owa-client-ids';

const styles = require('./QuickAddCalendarButton.scss');

export interface QuickAddCalendarButtonProps {
    displayName: string;
    emailAddress: string;
    mailboxType: string;
}

export default observer(function QuickAddCalendarButton(props: QuickAddCalendarButtonProps) {
    const onPeopleButtonClicked = () => {
        const { displayName, emailAddress, mailboxType } = props;
        logUsage('QuickAddCalendarFromSuggestion');
        lazyCreateLinkedCalendarAndSelect.importAndExecute(
            getUserMailboxInfo().userIdentity, // Assume primary account
            displayName,
            emailAddress,
            mailboxType
        );
        exitSearch('QuickAddCalendarFromSuggestion', SearchScenarioId.Calendar);
    };
    return (
        <TooltipHost content={loc(addCalendarButtonText)} id="actionButton">
            <IconButton
                iconProps={{
                    iconName: CalendarIcons.CalendarWeek,
                }}
                className={styles.personaSuggestionIconButton}
                name={loc(addCalendarButtonText)}
                aria-describedby="actionButton"
                onClick={onPeopleButtonClicked}
                aria-label={loc(addCalendarButtonText)}
            />
        </TooltipHost>
    );
});
